import { useIntl } from 'react-intl';
import { forwardRef } from '@chakra-ui/react';

import { Table } from '../../Table';
import { type RowProps } from '../../Table/parts';
import { useFees } from '../context';

export type CardPayinEuroProps = RowProps;

export const CardPayinEuro = forwardRef<CardPayinEuroProps, 'div'>(
  (props, ref) => {
    const intl = useIntl();
    const { fees, toFixed, toVariable } = useFees();

    const locales = {
      label: intl.formatMessage({
        id: 'subscription.fees_modal.card_payin_euro.label',
      }),
      value: intl.formatMessage(
        {
          id: 'subscription.fees_modal.card_payin_euro.value',
        },
        {
          fixed: toFixed(fees.cardPayinEuro),
          variable: toVariable(fees.cardPayinEuro),
        },
      ),
    };

    return (
      <Table.Row {...props} ref={ref}>
        <Table.CellText>{locales.label}</Table.CellText>
        <Table.CellAmount>{locales.value}</Table.CellAmount>
      </Table.Row>
    );
  },
);
